import { supabase } from '../../../shared/lib/supabaseClient';
import { logActivity } from '../../../shared/services/activityLogService';
import { describeFieldChanges, describeRecordDetails } from '../../../shared/utils/describeChanges';

const peso = (value) => `₱${Number(value).toLocaleString()}`;

const PROJECT_FIELD_LABELS = {
  name: 'name',
  category: 'category',
  amount: 'amount',
  expense_date: 'date',
  voucher_number: 'voucher number',
  recipient: 'recipient',
  status: 'status',
  remarks: 'remarks',
};
const formatProjectValue = (field, value) => (field === 'amount' ? peso(value) : value);

export async function getProjects() {
  const { data, error } = await supabase
    .from('projects')
    .select('*')
    .order('expense_date', { ascending: false });

  if (error) throw error;
  return data;
}

export async function createProject(projectData) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();
  if (userError) throw userError;

  const { error } = await supabase.from('projects').insert({
    ...projectData,
    created_by: user.id,
  });
  if (error) throw error;
  await logActivity('add_project', `Added project "${projectData.name}" (${peso(projectData.amount)})`);
}

export async function updateProject(id, projectData, previousData) {
  const { error } = await supabase.from('projects').update(projectData).eq('id', id);
  if (error) throw error;

  const changes = previousData
    ? describeFieldChanges({
        before: previousData,
        after: projectData,
        fields: PROJECT_FIELD_LABELS,
        formatValue: formatProjectValue,
      })
    : [];
  const description = changes.length
    ? `Updated ${changes.join(', ')} for "${projectData.name}"`
    : `Updated project "${projectData.name}"`;
  await logActivity('update_project', description);
}

export async function deleteProject(id, record) {
  const { error } = await supabase.from('projects').delete().eq('id', id);
  if (error) throw error;

  const displayName = record?.name || id;
  const details = describeRecordDetails({
    record,
    fields: PROJECT_FIELD_LABELS,
    exclude: ['name'],
    formatValue: formatProjectValue,
  });
  const description = details.length
    ? `Deleted project "${displayName}" (${details.join(', ')})`
    : `Deleted project "${displayName}"`;
  await logActivity('delete_project', description);
}
